import { Stack, Typography } from '@mui/material';
import { BarChart } from '@mui/x-charts';

import { DataNotFound } from '../page-404';

interface Props {
  chartSetting: any;
  title: string;
  dataSet: any;
}

const LeavesTakenCard = ({ chartSetting, title, dataSet }: Props) => {
  const noLeaves = dataSet.every((item: any) => item.leavesTaken === 0 && item.extraLeaves === 0);

  return (
    <Stack height="100%">
      <Typography variant="h6" ml={4} mt={1}>
        {title}
      </Typography>
      {noLeaves ? (
        <Stack
          sx={{
            height: '100%',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            padding: 2,
          }}
        >
          <DataNotFound height={200} />
        </Stack>
      ) : (
        <BarChart
          width={540}
          dataset={dataSet.map((item: any) => ({
            ...item,
            month: item.month.slice(0, 3),
          }))}
          xAxis={[{ scaleType: 'band', dataKey: 'month', label: 'Months' }]}
          {...chartSetting}
        />
      )}
    </Stack>
  );
};

export { LeavesTakenCard };
